import styled from 'styled-components';
import { DESKTOP_MIN_BREAK } from '#/shared/constants';

export const TripPlanErrorWrapper = styled.div`
  max-width: ${DESKTOP_MIN_BREAK};
  color: ${props => props.theme.secondaryFontColor};
  background-color: ${props => props.theme.backgroundColor};
`;

export const TripPlanErrorTitleRow = styled.div`
  text-align: center;
  display: flex;
  font-weight: bold;
  justify-content: center;
  flex-flow: row;
  box-sizing: border-box;
  width: 100%;
  font-size: 1.2em;
  padding-top: 11px;
`;

export const TripPlanErrorMessageRow = styled.div`
  display: flex;
  flex-flow: row;
  box-sizing: border-box;
  justify-content: center;
  width: 100%;
  padding: 6px 15px 15px 15px;
`;
